module.exports = function(ads) {
	'use strict'
	ads.directive('bannerSliderDir',bannerSliderDir);
	bannerSliderDir.$inject=[];
	function bannerSliderDir() {
		return {
			template: require('./partial/bannerSlider.html'),
			controller:'bannerSliderController',
			controllerAs:'vmbs',
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/adsModule/bannerSlider/js/directive/bannerSliderDirective.js
// module id = 480
// module chunks = 0